import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { User } from '../models/user';
import { Perfil } from '../models/perfil';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router, ActivatedRoute } from '@angular/router';
import { UsersService } from '../users.service';
import { LoaderService } from 'src/app/loader/loader.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-users-edit',
  templateUrl: './users-edit.component.html',
  styleUrls: ['./users-edit.component.scss'],
})
export class UsersEditComponent implements OnInit {
  env;
  user: User;
  profiles: Perfil[];
  companies: any[] = [];
  othersCompanies: any[] = [];

  timeoutIDError;

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};

  @ViewChild('alertError', { read: ElementRef, static: false })
  alertError: ElementRef;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private usersService: UsersService,
    private loaderService: LoaderService,
    private renderer: Renderer2,
    private permissionsService: PermissionsService
  ) {
    this.env = environment;
  }

  async ngOnInit() {
    this.setCompaniesDropdown();
    await this.handlePermissionsToGetPerfis();

    this.getUser(this.route.snapshot.paramMap.get('uid'));
  }

  onSubmit() {
    this.handleUserCompanies();
    this.updateUser(this.env.selected.cnpj, this.user);
  }

  async getUser(uid: string) {
    const loader = await this.loaderService.notifica({
      title: 'Buscando usuário...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.user = await this.usersService.getUser(uid).toPromise();

    this.filterCompaniesByUserPermissions();

    loader.dismiss();
  }

  async updateUser(cnpj: string, user: User) {
    const loader = await this.loaderService.notifica({
      title: 'Atualizando usuário...',
      date: moment().toISOString(),
      type: 'loading',
    });

    const updatedUser = await this.usersService.updateUser(cnpj, user).toPromise();

    if ('error' in updatedUser) {
      this.addErrorAlert(updatedUser.error);
    } else {
      this.router.navigateByUrl(`/users/${environment.selected.cnpj}`);
    }

    loader.dismiss();
  }

  private filterCompaniesByUserPermissions() {
    this.othersCompanies = this.user.empresas.filter(company => {
      for (let userCompany of this.env.user.empresas) {
        if (company.cnpj === userCompany.cnpj) {
          return false;
        }
      }
      return true;
    });

    this.companies = this.user.empresas.filter(company => {
      for (let userCompany of this.env.user.empresas) {
        if (company.cnpj === userCompany.cnpj) {
          return true;
        }
      }
      return false;
    });
  }

  private handleUserCompanies() {
    this.companies = this.companies.map(empresa => {
      return this.env.user.empresas.filter(emp => emp.cnpj === empresa.cnpj)[0];
    });

    this.user.empresas = [...this.companies, ...this.othersCompanies];
  }

  private async handlePermissionsToGetPerfis() {
    const profiles = await this.usersService.getPerfis().toPromise();

    if (!this.permissionsService.isProfile('Master')) {
      this.profiles = profiles.filter(profile => profile.nome !== 'Master');
    } else {
      this.profiles = profiles;
    }
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, 'innerHTML', msg);
    this.renderer.setProperty(this.alertError.nativeElement, 'hidden', false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, 'hidden', true);
    }, 8000);
  }

  setCompaniesDropdown() {
    this.dropdownList = this.env.user.empresas;

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'cnpj',
      textField: 'fantasia',
      selectAllText: 'Selecionar Todos',
      unSelectAllText: 'Deselecionar Todos',
      itemsShowLimit: 4,
      allowSearchFilter: true,
      searchPlaceholderText: 'Pesquisar',
      noDataAvailablePlaceholderText: 'Sem dados disponíveis',
    };
  }

  compareByName(itemOne, itemTwo) {
    return itemOne && itemTwo && itemOne.nome === itemTwo.nome;
  }

  goBack(): void {
    this.router.navigateByUrl(`/users/${this.env.selected.cnpj}`);
  }
}
